import type { SearchBarItem } from "@/types/searchBarItem";

export const searchBarItems: SearchBarItem[] = [
  {
    id: "searchTerm",
    inputReadonly: false,
    title: "where",
    defaultValue: "somewhere",
    component: "QuickSearchInput",
  },
  {
    id: "dateRange",
    inputReadonly: true,
    title: "when",
    defaultValue: "whenever",
    component: "DateRangePicker",
  },
  {
    id: "duration",
    inputReadonly: true,
    title: "how_long",
    defaultValue: "any_duration",
    component: "RangeInputDuration",
  },
];

export const searchTerm = "searchTerm";
